
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class JobWorkSettlementGrid extends Serenity.EntityGrid<JobWorkSettlementRow, any> {
        protected getColumnsKey() { return 'Production.JobWorkSettlement'; }
        protected getDialogType() { return JobWorkSettlementDialog; }
        protected getIdProperty() { return JobWorkSettlementRow.idProperty; }
        protected getInsertPermission() { return JobWorkSettlementRow.insertPermission; }
        protected getLocalTextPrefix() { return JobWorkSettlementRow.localTextPrefix; }
        protected getService() { return JobWorkSettlementService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(94);
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[94].AutoPosting;
            this.editItem(<JobWorkSettlementRow>{
                VoucherNo: voucherNo,
                UserId: Q.Authorization.userDefinition.UserId,
                VoucherTypeId: 94, 
                TransDate: now.toString(),
                CompanyId: Q.Authorization.userDefinition.CompanyId,
                FinancialYearId: Q.Authorization.userDefinition.FinancialYearId,
                CurrencyId: Q.Authorization.userDefinition.CurrencyId,
            });
        }
    }
}